export default '/elevate';
